module.exports = "./img/278950db25a522394818795c91684f83.png";